import { IRootState } from '@/redux/types'
import { BackupRounded } from '@mui/icons-material'
import { Box, FormHelperText, Grid, Typography } from '@mui/material'
import Dropzone from 'react-dropzone-uploader'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

interface NewsAddOnsTabContentProps {
  newState: any
  getUploadParams: any
}

export const NewsAddOnsTabContent = ({ newState, getUploadParams }: NewsAddOnsTabContentProps) => {
  const { t } = useTranslation(['global'])

  const { newsSelected } = useSelector((state: IRootState) => state.novelty)
  const { msgForm, errorForm } = useSelector((state: IRootState) => state.validator)

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="body2" color="text.secondary">
          {`${t('cover-image')}*`}
        </Typography>
        <Dropzone
          getUploadParams={getUploadParams}
          maxFiles={1}
          multiple={false}
          canCancel={false}
          classNames={{
            dropzone: 'dzu-dropzone-custom',
            inputLabel: 'dzu-inputlabel-custom'
          }}
          inputContent={
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <BackupRounded />
              {t('dropzone-text')}
            </Box>
          }
        />
        <FormHelperText error={errorForm.fileName}>{msgForm.fileName}</FormHelperText>
        {newsSelected !== null && newsSelected.image_url !== null && newState.fileName?.length === 0 && (
          <Box
            sx={{
              p: 1,
              display: 'grid',
              justifyContent: 'center',
              my: 2,
              borderRadius: 2,
              gridArea: 8,
              bgcolor: '#FAFAFA'
            }}
          >
            <Typography variant="body2">{`${t('preview')}:`}</Typography>
            <img
              src={`${import.meta.env.VITE_AWS_URL}/novelties/${newsSelected.image_url}`}
              width="100%"
              height="auto"
              alt={newsSelected.title}
            />
          </Box>
        )}
      </Grid>
    </Grid>
  )
}
